const firebaseConfig = {
  apiKey: "AIzaSyBxXmwkorkPIp0A-nPa0rF_dVDwwp6ZH6U",
  authDomain: "travelia-67766.firebaseapp.com",
  projectId: "travelia-67766",
  storageBucket: "travelia-67766.appspot.com",
  messagingSenderId: "1021832188459",
  appId: "1:1021832188459:web:99ae77cd156615e532906e",
};
export default firebaseConfig;